// Закрытие выпадашек тапом мимо в Safari/WebKit (iPhone).
//
// Выпадашки Radix (Select: сортировка, «Выбрать размер», размеры в коллекции;
// меню, поповеры) закрываются по «нажатию мимо». Для касания Radix ждёт не
// pointerdown, а следующий за ним `click` на document. Пока список открыт,
// у <body> стоит pointer-events: none, и тап попадает в <html>. WebKit
// присылает `click` после тапа только по «кликабельному» элементу — у которого
// есть свой обработчик click. У <html> и <body> его нет (React вешает
// обработчики на #root), поэтому `click` не приходит и список остаётся
// открытым. В Chromium `click` приходит всегда, поэтому там всё работало.
//
// Пустой обработчик на <html> и <body> делает их «кликабельными» для WebKit:
// после тапа мимо приходит `click`, и Radix закрывает список. Поведение
// остальных кликов не меняется — обработчик ничего не делает.
export function enableTapOutsideClose(doc: Document = document) {
	const noop = () => {};
	doc.documentElement.addEventListener("click", noop);
	doc.body?.addEventListener("click", noop);
}
